import { Button, Container, Stack } from "@mui/material";
import React, { useState } from "react";
import WeatherSubscriptions from "./WeatherSubscriptions";
import SubscribedWeatherAlerts from "./SubscribedWeatherAlerts";
import CustomAppBar from "../AppBar";
import { useTranslation } from "react-i18next";

const WeatherSubscriptionAndAlerts = () => {
  const [viewMode, setViewMode] = useState("subscribe");
  const { t } = useTranslation();

  return (
    <>
      <CustomAppBar />
      <Container
        maxWidth="xs"
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-start",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Stack direction="row" spacing={2} mb={3} mt={2}>
            <Button
              variant={viewMode === "subscribe" ? "contained" : "outlined"}
              onClick={() => setViewMode("subscribe")}
            >
              {t("Subscribe Alerts")}
            </Button>
            <Button
              variant={viewMode === "alerts" ? "contained" : "outlined"}
              onClick={() => setViewMode("alerts")}
            >
              {t("See Alerts")}
            </Button>
          </Stack>

          {viewMode === "subscribe" ? (
            <WeatherSubscriptions />
          ) : (
            <SubscribedWeatherAlerts />
          )}
        </div>
      </Container>
    </>
  );
};

export default WeatherSubscriptionAndAlerts;
